// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/EarlyCheckinSlotNotes.tsx
// 🔧 PURPOSE: Le due righe sotto le fasce del check-in anticipato
//             (ExtraServiceForm), perché una fascia spenta senza un motivo
//             non si capisce:
//             - il giorno dell'arrivo: "si prenota fino a 30 minuti prima";
//             - se chi parte dallo stesso appartamento esce tardi (late
//               check-out): "prima delle 14:00 non disponibile:
//               l'appartamento si libera più tardi". L'ora arriva dal
//               channel manager (options.earlyCheckinMinTime).
//             Le regole stanno in lib/earlyCheckin (e nel server).
// ============================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AppExtra } from '../lib/guestApi';
import { arrivalDayOf } from '../lib/earlyCheckin';
import { validTime } from '../lib/houseTimes';
import { romeDayKey } from '../lib/romeDay';

export interface EarlyCheckinSlotNotesProps {
  item: AppExtra;
  /** Il giorno dell'arrivo della prenotazione ("AAAA-MM-GG" o ISO). */
  checkIn?: string | null;
  /** "Adesso" (i test lo fissano). */
  now?: Date;
}

const EarlyCheckinSlotNotes: React.FC<EarlyCheckinSlotNotesProps> = ({ item, checkIn, now }) => {
  const { t } = useTranslation();
  const today = romeDayKey(now || new Date());
  const arrivalToday = !!today && arrivalDayOf(checkIn) === today;
  const minTime = validTime(item.options.earlyCheckinMinTime);
  const busy = !!minTime && (item.options.timeSlotOptions || []).some((s) => s.unavailableReason === 'apartment_busy');
  if (!arrivalToday && !busy) return null;
  return (
    <div className="mt-2 space-y-1 text-[13px] leading-snug text-gray-500 dark:text-gray-400">
      {busy ? <p>{t('extras.form.earlyApartmentBusy', { time: minTime })}</p> : null}
      {arrivalToday ? <p>{t('extras.form.earlyLeadNote')}</p> : null}
    </div>
  );
};

export default EarlyCheckinSlotNotes;
